// Registration consent version (2026-10-05).
//
// 2.0 = the ConsentScreen's current Privacy, Terms, Health Declaration and responsibility
// acknowledgment. The backend is authoritative (backend/main.py CURRENT_CONSENT_VERSION):
// GET /consent/check returns current_version and POST /consent rejects any other version (409).
// Bump this together with the backend constant AND the legal texts in ConsentScreen.jsx.
// 3.0 (2026-10-27) = the same documents naming OpenAI as an AI processor next to Google Gemini; everyone accepts again.
export const CONSENT_VERSION = '3.0';
